import React from 'react';
import { motion } from 'framer-motion';
export const CHECKOUT_URL = 'https://cosmetica-natural.impultienda.ar/checkout';
export const PRODUCT_NAME = 'COSMÉTICA NATURAL — LA GUÍA DEFINITIVA';
export const PRICE = '$24.990 ARS';
export const PRICE_SHORT = '$24.990';
export const PRICE_FULL = '$45.990';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LINK = 'https://wa.me/+5491234567890';
export const INSTAGRAM_LINK = 'https://instagram.com/lumen.akasha';
export const WEB_LINK = 'https://www.lumenakasha.com';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-299" data-mp="pcbcqkyllyek">
      {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-300" data-mp="34m7uhllob2c7">
          <div className="animate-aurora-1 absolute -top-16 left-[15%] h-80 w-80 rounded-full bg-brand-sageMist blur-[100px]" data-id="element-301" data-mp="30i00pa0cyw74" />
          <div className="animate-aurora-2 absolute -bottom-12 right-[12%] h-72 w-72 rounded-full bg-brand-roseMist blur-[110px]" data-id="element-302" data-mp="2vmccoxxm4937" />
        </div>}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'taupe' | 'gold';
};
export function CTAButton({
  children,
  href = '#comprar',
  className = '',
  fullWidth = false,
  variant = 'taupe'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-brand-gold text-brand-taupeDeep ring-1 ring-brand-goldDark/40 hover:bg-brand-goldLight' : 'bg-brand-taupe text-brand-cream ring-1 ring-brand-gold/50 hover:bg-brand-taupeDeep';
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold shadow-[0_10px_24px_rgba(94,74,52,.22)] transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-gold/50 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-303" data-mp="1y6rugx2pgear">
      {children}
    </motion.a>;
}